<template>
  <div class="drawer">
    <div class="drawer-container">
      <el-tabs v-model="activeName">
        <el-tab-pane :label="$t('procure.procureInfo')" name="detail">
          <div class="drawer-content with-tab">
            <el-form
              ref="procureForm"
              :model="procure"
              class="box"
              label-width="80px"
            >
              <fieldset class="mgb15">
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('procure.serialNo')">{{
                      procure.serialNo
                    }}</el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.workflowState')">
                      <state-label :state="procure.workflowState">
                        {{ $t("procureTypes." + procure.workflowState) }}
                      </state-label>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.owner')">{{
                      procure.ownerName
                    }}</el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.handOverAt')">{{
                      procure.handOverAt
                    }}</el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('procure.verifyAt')">{{
                      procure.verifyAt
                    }}</el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('procure.verifyName')">{{
                      procure.verifyName
                    }}</el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('procure.placeAt')">{{
                      procure.placeAt
                    }}</el-form-item>
                  </el-col>

                  <el-col :span="8">
                    <el-form-item :label="$t('procure.buyerName')">{{
                      procure.buyerName
                    }}</el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('procure.finishAt')">{{
                      procure.finishAt
                    }}</el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.createAt')">{{
                      procure.createdAt
                    }}</el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('settlement.amount')">
                      {{ computeTotal() | currency4 }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset>
                <legend>{{ $t("text.remark") }}</legend>
                <raw-html :content="procure.remark" />
              </fieldset>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('procure.procureItem')" name="item">
          <div class="drawer-content with-tab-footer">
            <div
              class="mgb10"
              v-if="
                Permit.canActionsChargeEdition('mmsProcureReceive') &&
                procure.finishAt == null &&
                procure.workflowState != 'newly'
              "
            >
              <el-button
                type="primary"
                size="mini"
                @click="receiveMatrialBatch"
                >{{ $t("action.receiveMatrial") }}</el-button
              >
              <el-button
                type="warning"
                size="mini"
                @click="receiveMatrialFinishBatch"
                >{{ $t("action.receiveMatrialFinish") }}</el-button
              >
            </div>
            <vxe-table
              :data="groupItems"
              :span-method="mergeMethod"
              id="materialsTable"
              @checkbox-change="selectRecord"
              @checkbox-all="selectAllRecords"
              row-id="id"
              ref="groupItemsTable"
              class="recordsTable"
              size="mini"
              resizable
              round
              highlight-hover-row
              auto-resize
              border
              :row-class-name="calculateBgColor"
              :scroll-y="{ enabled: false }"
            >
              <vxe-table-column field="checkbox" type="checkbox" width="35" />
              <vxe-table-column
                field="image"
                :title="$t('product.images')"
                width="82"
              >
                <template v-slot="{ row }">
                  <div v-if="row.isMerge">
                    {{ row.supplierName }}
                  </div>
                  <span v-else> <thumbnail :images="row.image" /> </span>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="materialSerialNo"
                :title="$t('material.serialNo')"
                min-width="100"
              >
                <template v-slot="{ row }">
                  {{ row.materialSerialNo }}
                  <div class="font10">
                    {{ row.materialName }} {{ row.subjectName }}
                  </div>
                  <div v-if="row.settlementId != null" class="green font10">
                    {{ $t("settleInfo.yes") }}
                  </div>
                  <div
                    v-if="
                      row.supplierMaterialNo != null &&
                      row.supplierMaterialNo != ''
                    "
                    class="font10 grey"
                  >
                    {{ row.supplierMaterialNo }}
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="color"
                :title="$t('material.color')"
                min-width="100"
              >
                <template v-slot="{ row }">
                  {{ row.color }}

                  <div class="font10">{{ row.colorNo }}</div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="quantity"
                :title="$t('text.quantity')"
                min-width="60"
              >
                <template v-slot="{ row }">
                  {{ row.quantity }}{{ row.unit }}
                </template>
              </vxe-table-column>

              <vxe-table-column
                field="price"
                :title="$t('material.inPrice')"
                min-width="80"
              >
                <template v-slot="{ row }">
                  {{ row.price | currency4 }}
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="receiveQuantity"
                :title="$t('procure.receiveQuantity')"
                min-width="80"
              >
                <template v-slot="{ row }">
                  <el-popover placement="right" width="700" trigger="click">
                    <vxe-table
                      :data="row.receives"
                      size="mini"
                      highlight-hover-row
                      :scroll-y="{ enabled: false }"
                    >
                      <vxe-table-column
                        field="receiveAt"
                        :title="$t('returnBack.receiveAt')"
                        min-width="110px"
                      />
                      <vxe-table-column
                        field="receiveName"
                        :title="$t('returnBack.receiverName')"
                        min-width="80px"
                      />
                      <vxe-table-column
                        field="quantity"
                        :title="$t('order.receiveQuantity')"
                        min-width="80px"
                      />
                      <vxe-table-column
                        field="receiveWarehouseName"
                        :title="$t('order.receiveShopName')"
                        min-width="80px"
                      />
                      <vxe-table-column
                        field="isQuality"
                        :title="$t('receive.qualityInfo')"
                        min-width="300px"
                      >
                        <template v-slot="{ row }">
                          <span>
                            <span v-if="row.isQuality">
                              <span v-if="row.qualityAt != null" class="green">
                                质:{{ row.qualityAt }}({{ row.qualityName }})
                                入仓量:{{ row.qualityQuantity }}
                              </span>
                              <span v-if="row.returnAt != null" class="orange">
                                退:{{ row.returnAt }}({{ row.returnName }})
                              </span>
                              <span
                                v-if="
                                  row.qualityAt == null && row.returnAt == null
                                "
                                class="red"
                                >{{ $t("menu.pengingQas") }}</span
                              >
                            </span>
                            <span v-if="!row.isQuality" class="grey-shallow">
                              {{ $t("qualityInfosMms.notNeedQuality") }}
                            </span>
                          </span>
                        </template>
                      </vxe-table-column>
                      <vxe-table-column
                        field="remark"
                        :title="$t('text.remark')"
                        min-width="60px"
                      />
                    </vxe-table>
                    <span
                      slot="reference"
                      class="popover-reference"
                      v-if="row.receiveQuantity != null"
                    >
                      {{ row.receiveQuantity }}{{ row.unit }}
                    </span>
                  </el-popover>

                  <div class="font10">
                    可用:
                    <span v-if="row.qualifiedQuantity != null">
                      {{ row.qualifiedQuantity }}{{ row.unit }}
                    </span>
                  </div>
                </template>
              </vxe-table-column>
              <!-- <vxe-table-column
                field="qualifiedQuantity"
                :title="$t('procure.qualifiedQuantity')"
                min-width="80"
              >
                <template v-slot="{ row }">
                  <span v-if="row.qualifiedQuantity != null">
                    {{ row.qualifiedQuantity }}{{ row.unit }}
                  </span>
                </template>
              </vxe-table-column> -->
              <vxe-table-column
                field="finishAt"
                :title="$t('procure.finishAt')"
                min-width="110"
              />
              <vxe-table-column
                field="remark"
                :title="$t('text.remark')"
                min-width="60"
              >
                <template v-slot="{ row }">
                  <raw-html-limit-number
                    :content="row.remark"
                    :number="6"
                    type="richText"
                  />
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="action"
                :title="$t('text.action')"
                width="130"
              >
                <template v-slot="{ row }">
                  <el-button
                    v-if="
                      Permit.canActionsChargeEdition('mmsProcureManage') &&
                      !(row.receiveQuantity > 0)
                    "
                    type="text"
                    size="mini"
                    @click="editItem(row)"
                    >{{ $t("text.edit") }}</el-button
                  >
                  <el-popconfirm
                    v-if="
                      Permit.canActionsChargeEdition('mmsProcureManage') &&
                      procure.verifyAt == null
                    "
                    :title="$t('prompt.confirmDelete')"
                    @confirm="deleteItem(row)"
                    class="mgl10"
                  >
                    <el-button slot="reference" type="text" size="mini">
                      {{ $t("text.delete") }}
                    </el-button>
                  </el-popconfirm>
                  <div>
                    <el-button
                      v-if="
                        Permit.canActionsChargeEdition('mmsProcureReceive') &&
                        row.materialId == null
                      "
                      type="text"
                      size="mini"
                      @click="addMaterial(row)"
                      >{{ $t("action.addMaterial") }}</el-button
                    >
                  </div>
                  <div
                    v-if="
                      Permit.canActionsChargeEdition('mmsProcureReceive') &&
                      row.materialId != null &&
                      row.finishAt == null &&
                      (Permit.currentUser().admin ||
                        Permit.mmsAuthSubjuctIds().includes(row.subjectId))
                    "
                  >
                    <el-button
                      v-if="procure.placeAt != null"
                      type="text"
                      size="mini"
                      @click="receiveMatrial(row)"
                    >
                      {{ $t("action.receiveMatrial") }}
                    </el-button>

                    <el-button
                      v-if="
                        procure.workflowState != 'newly' &&
                        !existUnQualityReceive(row)
                      "
                      type="text"
                      size="mini"
                      @click="finishItem(row)"
                    >
                      {{ $t("action.receiveMatrialFinish") }}
                    </el-button>
                  </div>
                </template>
              </vxe-table-column>
            </vxe-table>
          </div>
        </el-tab-pane>
        <el-tab-pane
          :label="$t('menu.relateOrders')"
          name="order"
          v-if="procure.type == 'Order'"
        >
          <vxe-table
            :data="procureOrders"
            ref="recordsTable"
            class="recordsTable"
            size="mini"
            id="recordsTable"
            row-id="id"
            :loading="loading"
            resizable
            round
            highlight-hover-row
            auto-resize
            :scroll-y="{ enabled: false }"
          >
            <vxe-table-column
              field="images"
              :title="$t('product.images')"
              width="85"
            >
              <template v-slot="{ row }">
                <thumbnail :images="row.images"></thumbnail>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="orderSerialNo"
              :title="$t('order.serialNo')"
              min-width="130"
            >
              <template v-slot="{ row }">
                {{ row.orderSerialNo }}
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="productNo"
              :title="$t('product.productNo')"
              min-width="100"
            >
              <template v-slot="{ row }">
                {{ row.productNo }}
                <div class="font10">{{ row.color }} {{ row.size }}</div>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="quantity"
              :title="$t('text.quantity')"
              min-width="60"
            >
              <template v-slot="{ row }">
                {{ row.quantity }}{{ row.unit }}
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="handOverAt"
              :title="$t('text.handOverAt')"
              min-width="110"
            ></vxe-table-column>
          </vxe-table>
        </el-tab-pane>
        <el-tab-pane
          :label="$t('menu.relatePurchases')"
          name="order"
          v-if="procure.type == 'Purchase'"
        >
          <vxe-table
            :data="procurePurchases"
            ref="recordsTable"
            class="recordsTable"
            size="mini"
            id="recordsTable"
            row-id="id"
            :loading="loading"
            resizable
            round
            highlight-hover-row
            auto-resize
            :scroll-y="{ enabled: false }"
          >
            <vxe-table-column
              field="images"
              :title="$t('product.images')"
              width="85"
            >
              <template v-slot="{ row }">
                <thumbnail :images="row.images"></thumbnail>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="purchaseSerialNo"
              :title="$t('purchase.serialNo')"
              min-width="130"
            >
              <template v-slot="{ row }">
                {{ row.purchaseSerialNo }}
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="productNo"
              :title="$t('product.productNo')"
              min-width="100"
            >
              <template v-slot="{ row }">
                {{ row.productNo }}
                <div class="font10">{{ row.color }} {{ row.size }}</div>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="quantity"
              :title="$t('text.quantity')"
              min-width="60"
            >
              <template v-slot="{ row }">
                {{ row.quantity }}{{ row.unit }}
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="handOverAt"
              :title="$t('text.handOverAt')"
              min-width="110"
            ></vxe-table-column>
          </vxe-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="drawer-footer">
      <el-button
        v-if="
          Permit.canActionsChargeEdition('mmsProcureManage') &&
          procure.verifyAt == null
        "
        type="success"
        size="small"
        @click="addProcureItem"
        >+ {{ $t("procure.procureItem") }}</el-button
      >

      <el-button
        size="small"
        type="default"
        @click="print('printProcureDiv')"
        >{{ $t("action.print") }}</el-button
      >
    </div>
    <!-- 编辑采购单项 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editItemDF"
      width="30%"
    >
      <el-form ref="editItemForm" :model="editItemObj" label-width="80px">
        <el-form-item
          :prop="'quantity'"
          :label="$t('text.quantity')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.quantity')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="editItemObj.quantity" />
        </el-form-item>
        <el-form-item :prop="'price'" :label="$t('material.inPrice')">
          <el-input size="small" v-model.trim="editItemObj.price" />
        </el-form-item>
        <el-form-item :label="$t('menu.suppliers')" :prop="'supplierId'">
          <!-- <el-select
            size="small"
            v-model="editItemObj.supplierId"
            clearable
            filterable
          >
            <el-option
              v-for="supplier in suppliers"
              :key="supplier.id"
              :label="supplier.name"
              :value="supplier.id"
            />
          </el-select> -->
          <el-select
            size="small"
            v-model="editItemObj.supplierId"
            filterable
            clearable
          >
            <el-option-group
              v-for="group in groupProductSuppliers()"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="supplier in group.suppliers"
                :key="supplier.supplierId"
                :label="
                  supplier.price
                    ? supplier.supplierName + '(¥' + supplier.price + ')'
                    : supplier.supplierName
                "
                :value="supplier.supplierId"
              ></el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item :prop="'remark'" :label="$t('text.remark')">
          <el-input
            size="small"
            v-model.trim="editItemObj.remark"
            type="textarea"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editItemDoing"
          size="small"
          @click="editItemSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editItemDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 新增到物料 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('menu.materials')"
      :close-on-click-modal="false"
      :visible.sync="addMaterialYesOrNoDF"
      width="30%"
    >
      <div class="center font18 mgb15">
        料号已存在，是否使用原有的料号信息？
      </div>
      <div class="center mgb30">
        <el-radio-group
          size="mini"
          v-model="addMaterialYesOrNoRadio"
          @change="selectAddMaterialYesOrNoRadio"
        >
          <el-radio label="yes" border>{{ $t("boolean.true") }}</el-radio>
          <el-radio label="no" border>{{ $t("boolean.false") }}</el-radio>
        </el-radio-group>
      </div>
      <br />
    </el-dialog>
    <!-- 新增到物料 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('action.addMaterial')"
      :close-on-click-modal="false"
      :visible.sync="addMaterialDF"
      width="50%"
    >
      <el-form ref="addMaterialForm" :model="addMaterialObj" label-width="90px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :prop="'serialNo'"
              :label="$t('material.serialNo')"
              :rules="[
                {
                  required: true,
                  validator: validateSerialNoAdd,
                  trigger: 'blur',
                },
              ]"
            >
              <el-input size="small" v-model.trim="addMaterialObj.serialNo" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :prop="'name'"
              :label="$t('material.name')"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('material.name')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-autocomplete
                size="small"
                v-if="procure.materialId == null"
                v-model.trim="addMaterialObj.name"
                style="width: 100%"
                :fetch-suggestions="querySearchNames"
                @select="handleSelectNames"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :prop="'subjectId'"
              :label="$t('material.subject')"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('material.subject')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-select size="small" v-model.trim="addMaterialObj.subjectId">
                <el-option
                  v-for="subject in subjects"
                  :key="subject.id"
                  :label="subject.name"
                  :value="subject.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$t('material.inUnit')"
              :prop="'inUnit'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('material.inUnit')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-autocomplete
                size="small"
                v-model.trim="addMaterialObj.inUnit"
                style="width: 100%"
                :fetch-suggestions="querySearchInUnits"
                @select="handleSelectInUnits"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="$t('material.outUnit')"
              :prop="'inUnit'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('material.outUnit')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-autocomplete
                size="small"
                v-model.trim="addMaterialObj.unit"
                style="width: 100%"
                :fetch-suggestions="querySearchUnits"
                @select="handleSelectUnits"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$t('material.exchange')"
              :prop="'exchange'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('material.exchange')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input size="small" v-model.trim="addMaterialObj.exchange" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :prop="'color'"
              :label="$t('material.color')"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('material.color')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-autocomplete
                size="small"
                v-model.trim="addMaterialObj.color"
                style="width: 100%"
                :fetch-suggestions="querySearchColors"
                @select="handleSelectColors"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :prop="'colorNo'"
              :label="$t('material.colorNo')"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('material.colorNo')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input size="small" v-model.trim="addMaterialObj.colorNo" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('menu.suppliers')" :prop="'supplierId'">
              <!-- <el-select
                size="small"
                v-model.trim="addMaterialObj.supplierId"
                clearable
                filterable
              >
                <el-option
                  v-for="supplier in suppliers"
                  :key="supplier.id"
                  :label="supplier.name"
                  :value="supplier.id"
                />
              </el-select> -->
              <el-select
                size="small"
                v-model="addMaterialObj.supplierId"
                filterable
                clearable
              >
                <el-option-group
                  v-for="group in groupProductSuppliers()"
                  :key="group.label"
                  :label="group.label"
                >
                  <el-option
                    v-for="supplier in group.suppliers"
                    :key="supplier.supplierId"
                    :label="
                      supplier.price
                        ? supplier.supplierName + '(¥' + supplier.price + ')'
                        : supplier.supplierName
                    "
                    :value="supplier.supplierId"
                  ></el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :prop="'price'" :label="$t('material.inPrice')">
              <el-input size="small" v-model.trim="addMaterialObj.price" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :prop="'image'" :label="$t('product.images')">
              <upload-single-picture v-model="addMaterialObj.image" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addMaterialDoing"
          size="small"
          @click="addMaterialSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addMaterialDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 收料 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('action.receiveMatrial')"
      :close-on-click-modal="false"
      :visible.sync="receiveMatrialDF"
      width="30%"
    >
      <el-form
        ref="receiveMatrialForm"
        :model="receiveMatrialObj"
        label-width="70px"
      >
        <el-form-item
          :prop="'quantity'"
          :label="$t('text.quantity')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.quantity')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="receiveMatrialObj.quantity"
            :placeholder="$t('text.quantity')"
          >
            <template slot="append" v-if="row">{{ row.unit }}</template>
          </el-input>
        </el-form-item>
        <el-form-item
          :prop="'receiveWarehouseId'"
          :label="$t('receive.receiveWarehouseVirtual')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [
                $t('receive.receiveWarehouseVirtual'),
              ]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model.trim="receiveMatrialObj.receiveWarehouseId"
          >
            <el-option
              v-for="warehouse in mmsAuthWarehouses"
              :key="warehouse.id"
              :label="warehouse.name"
              :value="warehouse.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item :prop="'remark'" :label="$t('text.remark')">
          <el-input
            size="small"
            v-model.trim="receiveMatrialObj.remark"
            :placeholder="$t('text.remark')"
            type="textarea"
          />
        </el-form-item>
        <el-form-item :prop="'isQuality'">
          <el-checkbox size="small" v-model="receiveMatrialObj.isQuality">{{
            $t("receive.isQuality")
          }}</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="receiveMatrialDoing"
          size="small"
          @click="receiveMatrialSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="receiveMatrialDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 批量收料 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('action.receiveMatrial')"
      :close-on-click-modal="false"
      :visible.sync="receiveMatrialBatchDF"
      width="30%"
    >
      <el-form
        ref="receiveMatrialBatchForm"
        :model="receiveMatrialBatchObj"
        label-width="70px"
      >
        <el-form-item
          :prop="'receiveWarehouseId'"
          :label="$t('receive.receiveWarehouseVirtual')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [
                $t('receive.receiveWarehouseVirtual'),
              ]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model="receiveMatrialBatchObj.receiveWarehouseId"
          >
            <el-option
              v-for="warehouse in mmsAuthWarehouses"
              :key="warehouse.id"
              :label="warehouse.name"
              :value="warehouse.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item :prop="'remark'" :label="$t('text.remark')">
          <el-input
            size="small"
            v-model.trim="receiveMatrialBatchObj.remark"
            :placeholder="$t('text.remark')"
            type="textarea"
          />
        </el-form-item>
        <el-form-item :prop="'isQuality'">
          <el-checkbox
            size="small"
            v-model="receiveMatrialBatchObj.isQuality"
            >{{ $t("receive.isQuality") }}</el-checkbox
          >
        </el-form-item>
        <div class="orange">
          {{ $t("prompt.receiveMatrialBatchExplain") }}
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="receiveMatrialBatchDoing"
          size="small"
          @click="receiveMatrialBatchSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="receiveMatrialBatchDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 新增采购单项 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('text.create')"
      :close-on-click-modal="false"
      :visible.sync="addProcureItemDF"
      width="30%"
    >
      <el-form
        ref="addProcureItemForm"
        :model="addProcureItemObj"
        label-width="60px"
      >
        <el-form-item
          :prop="'materialSerialNo'"
          :label="$t('material.serialNo')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('material.serialNoName')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-autocomplete
            size="small"
            v-model.trim="addProcureItemObj.materialSerialNo"
            :placeholder="$t('material.serialNoName')"
            style="width: 100%"
            :fetch-suggestions="querySearchSerialNo"
            @select="handleSelectSerialNo"
          >
            <template slot-scope="{ item }">
              <div class="name">{{ item.serialNo }}</div>
              <span class="addr">
                {{ item.name }}-{{ item.color }}
                <div class="addr">
                  {{ item.suppliersNoStr }}
                </div>
              </span>
            </template>
          </el-autocomplete>
          <span v-if="addProcureItemObj._invRepeatFg" class="red">{{
            $t("rules.exist", [$t("material.serialNo")])
          }}</span>
        </el-form-item>
        <el-row>
          <el-col :span="16">
            <el-form-item
              :prop="'quantity'"
              :label="$t('text.quantity')"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('text.quantity')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                size="small"
                v-model.trim="addProcureItemObj.quantity"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :prop="'unit'"
              label-width="0"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('material.inUnit')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                size="small"
                v-if="addProcureItemObj.materialId != null"
                v-model.trim="addProcureItemObj.unit"
                :placeholder="$t('material.inUnit')"
                disabled
              />

              <el-autocomplete
                size="small"
                v-if="addProcureItemObj.materialId == null"
                v-model.trim="addProcureItemObj.unit"
                style="width: 100%"
                :placeholder="$t('material.inUnit')"
                :fetch-suggestions="querySearchAddProcureItemUnits"
                @select="handleSelectAddProcureItemUnits"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('menu.suppliers')" :prop="'supplierId'">
          <!-- <el-select
            size="small"
            v-model="addProcureItemObj.supplierId"
            clearable
            filterable
          >
            <el-option
              v-for="supplier in suppliers"
              :key="supplier.id"
              :label="supplier.name"
              :value="supplier.id"
            />
          </el-select> -->
          <el-select
            size="small"
            v-model="addProcureItemObj.supplierId"
            filterable
            clearable
          >
            <el-option-group
              v-for="group in groupProductSuppliers()"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="supplier in group.suppliers"
                :key="supplier.supplierId"
                :label="
                  supplier.price
                    ? supplier.supplierName + '(¥' + supplier.price + ')'
                    : supplier.supplierName
                "
                :value="supplier.supplierId"
              ></el-option>
            </el-option-group>
          </el-select>
        </el-form-item>

        <el-form-item :prop="'remark'" :label="$t('text.remark')">
          <el-input
            size="small"
            v-model.trim="addProcureItemObj.remark"
            type="textarea"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addProcureItemDoing"
          size="small"
          @click="addProcureItemSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addProcureItemDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 打印 -->
    <div id="printProcureDiv" style="display: none">
      <div style="font-size: 12px">
        <div style="width: 100%; text-align: center; font-size: 16px">
          采购单
        </div>
        <br />
        <div>
          <div>
            <div style="float: left">
              {{ $t("procure.serialNo") }}：{{ procure.serialNo }}
            </div>
            <div style="float: right">
              {{ $t("text.owner") }}：{{ procure.ownerName }}&nbsp; &nbsp;{{
                $t("text.createAt")
              }}：{{ procure.createdAt }}
            </div>
          </div>
          <br />
          <div>
            <div style="float: left">
              {{ $t("text.remark") }}：{{ procure.remark }}
            </div>
            <div style="float: right">
              {{ $t("procure.buyerName") }}：{{ procure.buyerName }}&nbsp;
              &nbsp;{{ $t("procure.placeAt") }}：{{ procure.placeAt }}
            </div>
          </div>
        </div>
        <div>
          <table
            style="
              width: 100%;
              border-collapse: collapse;
              border: 1px solid black;
              font-size: 12px;
            "
          >
            <thead>
              <tr style="border: 1px solid black">
                <td style="border: 1px solid black">
                  {{ $t("material.serialNo") }}
                </td>
                <td style="border: 1px solid black">
                  {{ $t("material.name") }}
                </td>
                <td style="border: 1px solid black">
                  {{ $t("material.subject") }}
                </td>
                <td style="border: 1px solid black; width: 120px">
                  {{ $t("material.color") }}
                </td>
                <td style="border: 1px solid black; width: 80px">
                  {{ $t("text.quantity") }}
                </td>
                <td style="border: 1px solid black">
                  {{ $t("material.price") }}
                </td>
                <td style="border: 1px solid black; width: 80px">
                  {{ $t("procure.receiveQuantity") }}
                </td>
                <td style="border: 1px solid black">{{ $t("text.remark") }}</td>
              </tr>
            </thead>
            <tbody
              v-for="(item, groupItemIndex) of groupItems"
              :key="groupItemIndex"
            >
              <tr
                style="background-color: #eff8ff; height: 24px"
                v-if="item.isMerge"
              >
                <td
                  colspan="8"
                  style="border: 1px solid black; text-align: left"
                >
                  {{ item.supplierName }}
                </td>
              </tr>
              <tr v-else>
                <td style="border: 1px solid black">
                  {{ item.materialSerialNo
                  }}<span
                    v-if="
                      item.supplierMaterialNo != null &&
                      item.supplierMaterialNo != ''
                    "
                    style="font-size: 10px;color: #999999"
                  >
                    ({{ item.supplierMaterialNo }})
                  </span>
                </td>
                <td style="border: 1px solid black">
                  {{ item.materialName }}
                </td>
                <td style="border: 1px solid black">
                  {{ item.subjectName }}
                </td>
                <td style="border: 1px solid black">
                  {{ item.color }}({{ item.colorNo }})
                </td>

                <td style="border: 1px solid black">
                  {{ item.quantity }}{{ item.unit }}
                </td>
                <td style="border: 1px solid black">
                  {{ item.price | currency4 }}
                </td>
                <td style="border: 1px solid black">
                  {{ item.receiveQuantity }}{{ item.unit }}
                </td>
                <td style="border: 1px solid black; width: 200px">
                  {{ item.remark }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import { page } from "@/utils/mixins.js";
import Util from "@/utils";
import RawHtml from "@/components/RawHtml";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import UploadSinglePicture from "@/components/UploadSinglePicture";

import Procure from "@/api/procure.js";
import SupplierMms from "@/api/supplierMms.js";
import SubjectMms from "@/api/subjectMms.js";
import Color from "@/api/color.js";
import Material from "@/api/material.js";
import Warehouse from "@/api/warehouse.js";
import UserWarehouse from "@/api/userWarehouse.js";
import ReceiveMms from "@/api/receiveMms.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  components: {
    RawHtml,
    RawHtmlLimitNumber,
    UploadSinglePicture,
  },
  data() {
    var validateSerialNoAdd = (rule, value, callback) => {
      const self = this;
      if (value === null || value.trim() === "") {
        callback(
          new Error(this.$t("rules.required", [this.$t("bargain.serialNo")]))
        );
        return;
      }
      Material.findBySerialNo({ serialNo: value }).then(function (res) {
        if (self.row.materialId == null && res.data.code === 200) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("material.serialNo")]))
          );
        } else {
          callback();
        }
      });
    };
    return {
      activeName: "detail",
      procure: { workflowState: "newly" },
      procureOrders: [],
      procurePurchases: [],
      items: [],
      groupItems: [],
      printItems: [],
      isAllChecked: false,
      isIndeterminate: false,
      // selectProcureItems: [],
      // 编辑item
      subjects: [],
      editItemDF: false,
      editItemObj: {
        quantity: null,
        price: null,
        remark: null,
        materialId: null,
        materialSerialNo: null,
        materialName: null,
        unit: null,
        color: null,
        colorNo: null,
        subjectId: null,
        subjectName: null,
        supplierId: null,
        supplierName: null,
      },
      editItemDoing: false,
      suppliers: [],
      subjects: [],
      // 新增到物料
      validateSerialNoAdd: validateSerialNoAdd,
      row: null,
      addMaterialDF: false,
      addMaterialObj: {
        serialNo: null,
        name: null,
        subjectId: null,
        inUnit: null,
        unit: null,
        exchange: null,
        color: null,
        colorNo: null,
        price: null,
        remark: null,
        image: null,
        supplierId: null,
        supplierName: null,
      },
      addMaterialDoing: false,

      addMaterialYesOrNoDF: false,
      addMaterialYesOrNoRadio: null,
      // 收料
      receiveMatrialDF: false,
      receiveMatrialObj: {
        associateId: null,
        receiveWarehouseId: null,
        quantity: null,
        remark: null,
        isQuality: false,
      },
      receiveMatrialDoing: false,
      warehouses: [],
      userWarehouses: [],
      mmsAuthWarehouses: [],
      // 批量收料
      checkedRows: [],
      receiveMatrialBatchDF: false,
      receiveMatrialBatchObj: {
        receiveWarehouseId: null,
        isQuality: false,
        remark: null,
      },
      receiveMatrialBatchDoing: false,
      // 新增采购单项
      addProcureItemDF: false,
      materials: [],
      addProcureItemObj: {
        materialId: null,
        materialSerialNo: null,
        materialName: null,
        subjectId: null,
        subjectName: null,
        color: null,
        colorNo: null,
        unit: null,
        quantity: null,
        price: null,
        remark: null,
        _invRepeatFg: false,
        supplierId: null,
        supplierName: null,
      },
      addProcureItemDoing: false,
      //
      materialSuppliers: [],
    };
  },
  created() {
    this.getProcure();
    this.getItems();
  },
  methods: {
    // 打印采购单
    print(type) {
      this.printFunction(type);
    },
    getSubjects() {
      const self = this;
      SubjectMms.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.subjects = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getSuppliers() {
      const self = this;
      SupplierMms.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.suppliers = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getWarehouses() {
      const self = this;
      axios
        .all([
          Warehouse.findByTenantId(),
          UserWarehouse.findByUserId(self.Permit.currentUser().id),
        ])
        .then(
          axios.spread(function (warehouses, userWarehouses) {
            self.warehouses = warehouses.data;
            self.userWarehouses = userWarehouses.data;

            if (self.Permit.currentUser().admin) {
              self.mmsAuthWarehouses = self.warehouses;
            } else {
              const userWarehouseIds = self.userWarehouses.map(
                (u) => u.warehouseId
              );
              self.mmsAuthWarehouses = self.warehouses.filter((w) =>
                userWarehouseIds.includes(w.id)
              );
            }
          })
        );
    },
    groupProductSuppliers() {
      const self = this;
      const materialSuppliers = self.materialSuppliers;
      const materialSupplierIds = self.materialSuppliers.map(
        (ms) => ms.supplierId
      );
      const otherSuppliers = self.suppliers.filter(
        (p) => !materialSupplierIds.includes(p.id)
      );
      let data = [];
      if (materialSuppliers.length != 0) {
        data.push({
          label: "物料供应商",
          suppliers: materialSuppliers,
        });
      }
      if (otherSuppliers.length != 0) {
        data.push({
          label: "其他供应商",
          suppliers: otherSuppliers.map((m) => {
            return {
              supplierId: m.id,
              supplierName: m.name,
            };
          }),
        });
      }
      if (data.length !== 0 && data.length == 1) {
        data[0].label = "";
      }
      return data;
    },
    // 新增采购单项
    addProcureItem() {
      const self = this;
      self.addProcureItemObj.materialId = null;
      self.addProcureItemObj.materialSerialNo = null;
      self.addProcureItemObj.materialName = null;
      self.addProcureItemObj.subjectId = null;
      self.addProcureItemObj.subjectName = null;
      self.addProcureItemObj.color = null;
      self.addProcureItemObj.colorNo = null;
      self.addProcureItemObj.unit = null;
      self.addProcureItemObj.quantity = null;
      self.addProcureItemObj.price = null;
      self.addProcureItemObj.remark = null;
      self.addProcureItemObj.supplierId = null;
      self.addProcureItemObj.supplierName = null;
      self.addProcureItemObj._invRepeatFg = null;
      self.materialSuppliers = [];
      self.getSuppliers();
      self.addProcureItemDF = true;
    },
    querySearchSerialNo(queryString, cb) {
      const self = this;
      self.addProcureItemObj.materialId = null;
      self.addProcureItemObj.materialName = null;
      self.addProcureItemObj.subjectId = null;
      self.addProcureItemObj.subjectName = null;
      self.addProcureItemObj.color = null;
      self.addProcureItemObj.colorNo = null;
      self.addProcureItemObj.unit = null;
      self.addProcureItemObj.quantity = null;
      self.addProcureItemObj.price = null;
      self.addProcureItemObj.remark = null;
      self.addProcureItemObj._invRepeatFg = null;
      self.materialSuppliers = [];
      if (queryString == null || queryString.length < 1) {
        return;
      }
      Material.vagueFindBySerialNoOrName({ serialNo: queryString }).then(
        function (res) {
          self.materials = res.data;
          if (self.materials.length !== 0) {
            for (const material of self.materials) {
              Vue.set(material, "value", material.serialNo);
            }
          }
          cb(self.materials);
        }
      );
    },
    handleSelectSerialNo(item) {
      const self = this;
      self.addProcureItemObj._invRepeatFg = false;
      self.addProcureItemObj.materialId = item.id;
      self.addProcureItemObj.materialName = item.name;
      self.addProcureItemObj.subjectId = item.subjectId;
      self.addProcureItemObj.subjectName = item.subjectName;
      self.addProcureItemObj.color = item.color;
      self.addProcureItemObj.colorNo = item.colorNo;
      self.addProcureItemObj.unit = item.inUnit;
      self.addProcureItemObj.quantity = null;
      self.addProcureItemObj.price = item.inPrice;
      self.addProcureItemObj.remark = null;
      self.materialSuppliers = item.materialSuppliers;
      if (item.defaultSupplier != null) {
        self.addProcureItemObj.supplierId = item.defaultSupplier.supplierId;
        self.addProcureItemObj.supplierName = item.defaultSupplier.supplierName;
      }
      if (
        self.items.find(
          (i) => i.materialSerialNo === self.addProcureItemObj.materialSerialNo
        ) != null
      ) {
        self.addProcureItemObj._invRepeatFg = true;
      }
    },

    // 单位
    querySearchAddProcureItemUnits(queryString, cb) {
      Material.getInUnits().then(function (res) {
        const units = res.data.map((item) => {
          return { value: item };
        });
        cb(units);
      });
    },
    handleSelectAddProcureItemUnits() {
      this.addProcureItemObj.unit = this.addProcureItemObj.unit;
    },
    addProcureItemSubmit() {
      const self = this;
      self.$refs.addProcureItemForm.validate((valid) => {
        if (valid) {
          if (self.addProcureItemObj.supplierId != null) {
            self.addProcureItemObj.supplierName = self.suppliers.find(
              (s) => s.id === self.addProcureItemObj.supplierId
            ).name;
          }
          self.addProcureItemDoing = true;
          Procure.addProcureItems(self.procure.id, [
            self.addProcureItemObj,
          ]).then(function (res) {
            self.addProcureItemDoing = false;
            self.addProcureItemDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
              self.getItems();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 批量批量收料完成
    receiveMatrialFinishBatch() {
      const self = this;
      const unFinishedCheckedRows = self
        .selectProcureItems()
        .filter(
          (c) =>
            c.finishAt == null &&
            !self.existUnQualityReceive(c) &&
            c.materialId != null
        );
      if (unFinishedCheckedRows.length === 0) {
        self.$message({
          message: self.$t("prompt.atLeastOneDataUnFinish"),
          type: "warning",
        });
        return;
      }
      if (confirm(this.$t("prompt.confirmReceiveMatrialFinish"))) {
        Procure.batchFinishItem(
          self.id,
          unFinishedCheckedRows.map((c) => c.id)
        ).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.receiveMatrialFinishSuccess"),
              type: "success",
            });
            self.getProcure();
            self.getItems();
            self.$emit("updateInfo");
          } else {
            self.sysError();
          }
        });
      }
    },
    //批量收料
    receiveMatrialBatch() {
      const self = this;
      const unFinishedCheckedRows = self
        .selectProcureItems()
        .filter(
          (c) =>
            c.finishAt == null &&
            c.receiveQuantity < c.quantity &&
            c.materialId != null
        );
      if (unFinishedCheckedRows.length === 0) {
        self.$message({
          message: self.$t("prompt.atLeastOneDataUnReceiveMaterial"),
          type: "warning",
        });
        return;
      }
      self.receiveMatrialBatchObj.receiveWarehouseId = null;
      self.receiveMatrialBatchObj.remark = null;
      self.getWarehouses();
      self.receiveMatrialBatchObj.isQuality = false;
      self.receiveMatrialBatchDF = true;
    },
    receiveMatrialBatchSubmit() {
      const self = this;
      self.$refs.receiveMatrialBatchForm.validate((valid) => {
        if (valid) {
          const unFinishedCheckedRows = self
            .selectProcureItems()
            .filter(
              (c) => c.finishAt == null && c.receiveQuantity < c.quantity
            );
          const datas = unFinishedCheckedRows.map((c) => {
            return {
              associateId: c.id,
              receiveWarehouseId:
                self.receiveMatrialBatchObj.receiveWarehouseId,
              quantity: c.quantity - c.receiveQuantity || 0,
              isQuality: self.receiveMatrialBatchObj.isQuality,
              remark: self.receiveMatrialBatchObj.remark,
            };
          });
          self.receiveMatrialBatchDoing = true;
          ReceiveMms.insertBatch(datas).then(function (res) {
            self.receiveMatrialBatchDoing = false;
            self.receiveMatrialBatchDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.receiveMatrialSuccess"),
                type: "success",
              });
              self.getProcure();
              self.getItems();
              self.$emit("updateInfo");
              self.$eventHub.$emit("receiveMmsInsertBatch");
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 收料完成
    existUnQualityReceive(row) {
      const unQualityReceives = row.receives.filter(
        (r) => r.isQuality === true && r.qualityAt == null && r.returnAt == null
      );
      return unQualityReceives.length !== 0;
    },
    finishItem(row) {
      const self = this;
      Procure.finishItem(self.procure.id, row.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.receiveMatrialFinishSuccess"),
            type: "success",
          });
          self.getProcure();
          self.getItems();
          self.$emit("updateInfo");
        } else {
          self.sysError();
        }
      });
    },
    // 收料
    receiveMatrial(row) {
      const self = this;
      self.row = row;
      self.receiveMatrialObj.associateId = row.id;
      self.receiveMatrialObj.receiveWarehouseId = null;
      self.receiveMatrialObj.isQuality = false;
      if (row.quantity - (row.receiveQuantity || 0) > 0) {
        self.receiveMatrialObj.quantity =
          row.quantity - (row.receiveQuantity || 0);
      } else {
        self.receiveMatrialObj.quantity = null;
      }
      self.receiveMatrialObj.remark = null;
      self.getWarehouses();
      self.receiveMatrialDoing = false;
      self.receiveMatrialDF = true;
    },
    receiveMatrialSubmit() {
      const self = this;
      self.$refs.receiveMatrialForm.validate((valid) => {
        if (valid) {
          if (!Util.regexQuantity(self.receiveMatrialObj.quantity)) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("text.quantity")]),
              type: "warning",
            });
            return;
          }
          self.receiveMatrialDoing = true;
          ReceiveMms.insertBatch([self.receiveMatrialObj]).then(function (res) {
            self.receiveMatrialDoing = false;
            self.receiveMatrialDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.receiveMatrialSuccess"),
                type: "success",
              });
              self.getProcure();
              self.getItems();
              self.$emit("updateInfo");
              self.$eventHub.$emit("receiveMmsInsertBatch");
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 新增到物料
    addMaterial(row) {
      const self = this;
      self.row = row;
      // console.log("===", row);
      self.addMaterialYesOrNoRadio = null;
      self.getSubjects();
      self.getSuppliers();
      Material.findBySerialNo({ serialNo: row.materialSerialNo }).then(
        function (res) {
          if (res.data.code === 200) {
            self.addMaterialYesOrNoDF = true;
            self.editItemObj.materialId = res.data.entity.id;
            self.editItemObj.materialSerialNo = row.materialSerialNo;
            self.editItemObj.materialName = res.data.entity.name;
            self.editItemObj.subjectId = res.data.entity.subjectId;
            self.editItemObj.subjectName = res.data.entity.subjectName;
            self.editItemObj.unit = res.data.entity.unit;
            self.editItemObj.color = res.data.entity.color;
            self.editItemObj.colorNo = res.data.entity.colorNo;
            self.editItemObj.supplierId = res.data.entity.supplierId;
            self.editItemObj.supplierName = res.data.entity.supplierName;
            self.editItemObj.quantity = row.quantity;
            self.editItemObj.price = row.price;
            self.editItemObj.remark = row.remark;
            self.editItemObj.image = res.data.entity.image;
          } else {
            self.addMaterialYes();
          }
        }
      );
    },
    selectAddMaterialYesOrNoRadio() {
      const self = this;
      if (self.addMaterialYesOrNoRadio === "yes") {
        Procure.updateItem(self.procure.id, self.row.id, self.editItemObj).then(
          function (res) {
            if (res.status === 200) {
              self.addMaterialYesOrNoDF = false;
              self.getItems();
            } else {
              self.sysError();
            }
          }
        );
      } else {
        self.addMaterialYes();
      }
    },
    addMaterialYes() {
      const self = this;
      self.addMaterialObj.serialNo = self.row.materialSerialNo;
      self.addMaterialObj.inUnit = self.row.unit;
      self.addMaterialObj.unit = null;
      self.addMaterialObj.exchange = null;
      self.addMaterialObj.supplierId = self.row.supplierId;
      self.addMaterialObj.supplierName = self.row.supplierName;
      self.addMaterialObj.image = self.row.image;
      self.addMaterialYesOrNoDF = false;
      self.addMaterialObj.subjectId = null;
      self.addMaterialObj.color = null;
      self.addMaterialObj.colorNo = null;
      self.addMaterialObj.price = self.row.price;
      self.materialSuppliers = [];
      self.addMaterialDF = true;
    },
    // 品名
    querySearchNames(queryString, cb) {
      Material.getNames().then(function (res) {
        const names = res.data.map((item) => {
          return { value: item };
        });
        cb(names);
      });
    },
    handleSelectNames(index) {
      this.addMaterialObj.name = this.addMaterialObj.name;
    },
    // 单位
    querySearchInUnits(queryString, cb) {
      Material.getInUnits().then(function (res) {
        const units = res.data.map((item) => {
          return { value: item };
        });
        cb(units);
      });
    },
    handleSelectInUnits(item) {
      this.addMaterialObj.inUnit = item.value;
    },
    // 单位
    querySearchUnits(queryString, cb) {
      Material.getUnits().then(function (res) {
        const units = res.data.map((item) => {
          return { value: item };
        });
        cb(units);
      });
    },
    handleSelectUnits(item) {
      this.addMaterialObj.unit = item.value;
    },
    // 颜色
    querySearchColors(queryString, cb) {
      Color.findByTenantId().then(function (res) {
        const colors = res.data.map((item) => {
          return { value: item.name };
        });
        cb(colors);
      });
    },
    handleSelectColors(index) {
      this.addMaterialObj.color = this.addMaterialObj.color;
    },
    addMaterialSubmit() {
      const self = this;
      self.$refs.addMaterialForm.validate((valid) => {
        if (valid) {
          self.addMaterialDoing = true;
          self.addMaterialObj.subjectName = self.subjects.find(
            (s) => s.id === self.addMaterialObj.subjectId
          ).name;
          if (self.addMaterialObj.supplierId != null) {
            self.addMaterialObj.suppliertName = self.suppliers.find(
              (s) => s.id === self.addMaterialObj.supplierId
            ).name;
          } else {
            self.addMaterialObj.suppliertName = null;
          }
          Procure.addToMaterial(
            self.procure.id,
            self.row.id,
            self.addMaterialObj
          ).then(function (res) {
            self.addMaterialDoing = false;
            self.addMaterialDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
              self.getItems();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 删除
    deleteItem(row) {
      const self = this;
      Procure.deleteItem(self.$route.params.id, row.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.delSuccess"),
            type: "success",
          });
          self.getItems();
        } else {
          self.sysError();
        }
      });
    },
    // 编辑
    editItem(row) {
      const self = this;
      self.row = row;
      self.getSuppliers();
      self.editItemObj.materialId = row.materialId;
      self.editItemObj.materialSerialNo = row.materialSerialNo;
      self.editItemObj.materialName = row.materialName;
      self.editItemObj.unit = row.unit;
      self.editItemObj.color = row.color;
      self.editItemObj.colorNo = row.colorNo;
      self.editItemObj.subjectId = row.subjectId;
      self.editItemObj.subjectName = row.subjectName;
      self.editItemObj.quantity = row.quantity;
      self.editItemObj.price = row.price;
      self.editItemObj.remark = row.remark;
      self.editItemObj.supplierId = row.supplierId;
      self.editItemObj.supplierName = row.supplierName;
      self.materialSuppliers = [];
      if (row.materialId != null) {
        Material.findById(row.materialId).then(function (res) {
          if (res.data.code === 200) {
            self.materialSuppliers = res.data.entity.materialSuppliers;
            self.editItemDF = true;
          } else {
            self.sysError();
          }
        });
      } else {
        self.editItemDF = true;
      }
    },
    editItemSubmit() {
      const self = this;
      self.$refs.editItemForm.validate((valid) => {
        if (valid) {
          if (self.editItemObj.supplierId != null) {
            self.editItemObj.supplierName = self.suppliers.find(
              (s) => s.id === self.editItemObj.supplierId
            ).name;
          } else {
            self.editItemObj.supplierName = null;
          }
          self.editItemDoing = true;
          Procure.updateItem(
            self.procure.id,
            self.row.id,
            self.editItemObj
          ).then(function (res) {
            self.editItemDoing = false;
            self.editItemDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.getItems();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    computeTotal() {
      let total = 0;
      if (this.items.length !== 0) {
        for (const item of this.items) {
          total = total + item.price * item.quantity;
        }
        return total;
      }
      return 0;
    },
    getProcure() {
      const self = this;
      self.loadingStart();
      Procure.findById(self.id).then(function (res) {
        if (res.data.code === 200) {
          self.procure = res.data.entity;
          if (self.procure.type == "Order") {
            self.getProcureOrders();
          }
          if (self.procure.type == "Purchase") {
            self.getProcurePurchases();
          }
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },
    getProcureOrders() {
      const self = this;
      Procure.procureOrders(self.procure.id).then(function (res) {
        if (res.status == 200) {
          self.procureOrders = res.data;
        } else {
          self.sysError();
        }
      });
    },

    getProcurePurchases() {
      const self = this;
      Procure.procurePurchases(self.procure.id).then(function (res) {
        if (res.status == 200) {
          self.procurePurchases = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getItems() {
      const self = this;
      Procure.findItems(self.id).then(function (res) {
        if (res.status === 200) {
          self.items = res.data;
          self.groupItems = self.buildTableData(self.items);
        } else {
          self.sysError();
        }
      });
    },

    buildTableData(materals) {
      const self = this;
      if (materals.length === 0) {
        return [];
      }
      self.printItems = [];
      const supplierIds = materals.map((b) => b.supplierId);
      const supplierIdsSet = [...new Set(supplierIds)];
      let groupMaterials = [];
      for (const supplierId of supplierIdsSet) {
        const currentSupplierMaterials = materals.filter(
          (b) => b.supplierId == supplierId
        );
        groupMaterials.push({
          isMerge: true,
          supplierId: supplierId,
          supplierName: currentSupplierMaterials[0].supplierName,
          materials: currentSupplierMaterials,
        });

        for (const material of currentSupplierMaterials) {
          groupMaterials.push(material);
        }
        self.printItems.push({
          isMerge: true,
          supplierId: supplierId,
          supplierName: currentSupplierMaterials[0].supplierName,
          materials: currentSupplierMaterials,
        });
      }
      return groupMaterials;
    },
    buildMergeCells() {
      let mcs = [];
      for (let i = 0, rowIdx = 0; i < this.groupItems.length; i++) {
        mcs.push({ row: rowIdx, col: 1, rowspan: 1, colspan: 9 });
        if (this.groupItems[i].materials) {
          rowIdx = rowIdx + this.groupItems[i].materials.length + 1;
        }
      }
      return mcs;
    },
    mergeMethod({ rowIndex, columnIndex }) {
      const mergeCells = this.buildMergeCells();
      for (let mIndex = 0; mIndex < mergeCells.length; mIndex++) {
        const { row, col, rowspan, colspan } = mergeCells[mIndex];
        if (row === rowIndex && col === columnIndex) {
          return { rowspan, colspan };
        }
        if (
          rowIndex >= row &&
          rowIndex < row + rowspan &&
          columnIndex >= col &&
          columnIndex < col + colspan
        ) {
          return { rowspan: 0, colspan: 0 };
        }
      }
      return { rowspan: 1, colspan: 1 };
    },
    calculateBgColor({ row, rowIndex }) {
      return row.isMerge ? "light-blue-bg" : "";
    },

    selectProcureItemsSuppliers() {
      return this.$refs.groupItemsTable
        .getCheckboxRecords()
        .filter((r) => r.isMerge);
    },
    selectProcureItems() {
      return this.$refs.groupItemsTable
        .getCheckboxRecords()
        .filter((r) => !r.isMerge);
    },

    // checkboxChangeEvent({ records }) {
    //   this.isAllChecked = this.$refs.procureItemsTable.isAllCheckboxChecked();
    //   this.isIndeterminate = this.$refs.procureItemsTable.isCheckboxIndeterminate();
    //   this.selectProcureItems = records;
    // },
    // changeAllEvent() {
    //   this.$refs.procureItemsTable.setAllCheckboxRow(this.isAllChecked);
    //   this.selectProcureItems = this.$refs.procureItemsTable.getCheckboxRecords();
    // },

    selectRecord({ rowIndex, selection, checked, row, data }) {
      if (row.isMerge) {
        let materials = data.filter((r) => r.supplierId == row.supplierId);
        this.$refs.groupItemsTable.setCheckboxRow(materials, checked);
      }
    },
    selectAllRecords() {
      // this.setSelectedQty();
    },
  },
};
</script>